/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Quotes_Russell_TextInputs */

const en_home_quotes_russell_text = /** @type {(inputs: Home_Quotes_Russell_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If we pursue [our current approach], then we will eventually lose control over the machines.`)
};

/**
* | output |
* | --- |
* | "If we pursue [our current approach], then we will eventually lose control over the machines." |
*
* @param {Home_Quotes_Russell_TextInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_quotes_russell_text = /** @type {((inputs?: Home_Quotes_Russell_TextInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Quotes_Russell_TextInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_quotes_russell_text(inputs)
});